import { Cookie } from 'cookies';
import { PATH_SUBTITLE } from 'src/services/shared/constants';

export const generateSignature = (params: string[]) => {
  const newParams = params.filter((elem, i) => params.indexOf(elem) === i);
  return newParams.join('&');
};

export const formatCookies = (cookie: Cookie) => {
  const key = cookie.name.replace('CloudFront-', '');
  return `${key}=${cookie.value}`; 
};

interface IParams {
  cookiesVideo: string[],
  cookiesSubtitle: string[]
}

export const generateCloudfrontSignature = (cookies: Cookie[]) => {
  const params: IParams = { cookiesVideo: [], cookiesSubtitle: [] };

  for (const cookie of cookies) {
    if (cookie.path.includes(PATH_SUBTITLE)) {
      params.cookiesSubtitle.push(formatCookies(cookie)); 
    } else {
      params.cookiesVideo.push(formatCookies(cookie)); 
    }
  }

  return {
    cookiesVideo: generateSignature(params.cookiesVideo),
    cookiesSubtitle: generateSignature(params.cookiesSubtitle)
  };
};

export const signCloudfrontUrl = (url, signature) => {
  const signedUrl = !url.includes('?') ? `${url}?${signature}` : `${url}${signature}`;
  return signedUrl;
};